import { Component, OnInit, OnDestroy, AfterViewInit, inject, input } from "@angular/core";
import { DomSanitizer, SafeStyle } from "@angular/platform-browser";
import { filter } from "rxjs/operators";
import { Subscription } from "rxjs";
import { ButtonComponent } from "@husbanken/designsystem-angular-core";
import { QlikService } from "../../services/qlik.service";
import { IQlikLib } from "../../qliklib/qliklib";

@Component({
  selector: "stat-qlik-table",
  templateUrl: "./table.component.html",
  imports: [ButtonComponent],
})
export class TableComponent implements OnInit, AfterViewInit, OnDestroy {
  private qlikService = inject(QlikService);
  private sanitizer = inject(DomSanitizer);

  readonly id = input<string>(); // Qlik graph object id
  readonly height = input(300); // Height of the graph box (is set in Qlik)
  readonly width = input<number | "auto">("auto");
  readonly omHovedtall = input<string>();
  readonly visExcel = input(false);
  readonly noSelections = input(false); //Styrer om det er mulig å gjøre filtervalg i grafen
  readonly noInteraction = input(false); //Styrer om grafen reagerer på klikk, hover, scroll o.l.
  readonly valgtFilter = input<string>(); //Hvilke filter fra filterlisten som er valgt

  objectKeys = Object.keys;
  sizeStyle: SafeStyle = null;
  idPrefix = "qv-graf-";
  visDatagrunnlagUtvidet = false;
  // Collector for closing observables when done
  collector: Subscription = new Subscription();

  saveAsExcel() {
    this.qlikService.saveAsExcel(this.idPrefix + this.id(), this.valgtFilter());
  }

  ngOnInit() {
    let style = "height: " + this.height() + "px;";
    const width = this.width();
    if (width !== "auto") {
      style += " width: " + width + "px;";
    }
    this.sizeStyle = this.sanitizer.bypassSecurityTrustStyle(style);
  }

  ngAfterViewInit() {
    this.qlikService
      .getQliklib()
      .pipe(filter(qliklib => qliklib))
      .subscribe((qliklib: IQlikLib) => {
        const id = this.id();
        if (this.qlikService.isGrafId(id)) {
          const selector = "#" + this.idPrefix + id;

          const options = {
            noInteraction: this.noInteraction(),
            noSelections: this.noSelections(),
          };

          qliklib.displayQlikObjects(selector, options);
        } else {
          throw "Error: Qlik object ID '" + id + "' not registered";
        }
      })
      .add(this.collector);
  }

  ngOnDestroy() {
    this.qlikService
      .getQliklib()
      .subscribe((qliklib: IQlikLib) => {
        qliklib?.closeQlikObjects(this.idPrefix + this.id());
      })
      .unsubscribe();

    this.collector.unsubscribe();
  }

  hentFilterListe() {
    let list = [];
    let filterDescription = this.omHovedtall();
    list = this.qlikService.hentValgtFilterListe(this.valgtFilter());
    if (list && list.length > 0) {
      filterDescription = filterDescription + " for " + list + ".";
    }
    return filterDescription;
  }
}
